import './VolumeCurveGrid.scss';
import { VolumeCurveData } from 'widgets/volumeCurve/data/volumeCurveData.ts';
import React, { useContext, useMemo } from 'react';
import {
    getVolumeCurveColDefs,
    VolumeCurveGridColumn,
    volumeCurveGridColumnsDefinitionDictionary,
} from './columns';
import AppContext from 'app/AppContext.tsx';
import { useWidgetGridState } from 'widgets/store/grid/useWidgetGridState.ts';
import { BucketedDataItem } from 'utils/timeseries/bucket.ts';
import { Grid, GridApi } from '@instinet-analytics/semantic-ui-components';
import { useVolumeCurveDimensions } from 'widgets/volumeCurve/components/dimensions.ts';

export default function VolumeCurveGrid({
    data,
    onGridApiSet,
}: {
    data: VolumeCurveData;
    onGridApiSet: (gridApi: GridApi) => void;
}) {
    const rows = data.bucketedData;
    const context = useContext(AppContext);

    const colDefs = useMemo(() => getVolumeCurveColDefs(context), [context]);

    const { bodyHeight } = useVolumeCurveDimensions();

    const { gridPropsFromState, columnDefs } = useWidgetGridState<
        BucketedDataItem,
        VolumeCurveGridColumn
    >(volumeCurveGridColumnsDefinitionDictionary, colDefs);

    const onGridReady = (api: GridApi) => {
        onGridApiSet(api);
    };

    return (
        <div className="VolumeCurveGrid" style={{ height: bodyHeight + 'px' }}>
            <Grid
                className={'volume-curve-grid ag-theme-balham-dark'}
                columnDefs={columnDefs}
                rowData={rows}
                getRowDataId={(d: BucketedDataItem) => d.midTime.toString()}
                suppressColumnVirtualisation={false}
                onGridReady={onGridReady}
                {...gridPropsFromState}
            />
        </div>
    );
}
